import { arrayOf, bool, exact, string } from 'prop-types';

export const ItemsType = exact({
  collectible: bool.isRequired,
  color: string.isRequired,
  id: string.isRequired,
  label: string.isRequired,
});

export const CategoryType = exact({
  id: string.isRequired,
  items: arrayOf(ItemsType).isRequired,
  label: string.isRequired,
});

export const CategoriesType = arrayOf(CategoryType);
